module.exports = new __parcel__URL__("bossfight_status_not_started.d509ca96.png").toString();